
export default {
  props: {
    transfer: {
      default: () => [],
    },
  },
}
